import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=682d9017&scoped=true"
import script from "./CallsList.vue?vue&type=script&lang=js"
export * from "./CallsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d9017",
  null
  
)

export default component.exports